export const SCE_MODULES = {
    accessibility: 'accessibility',
    misspelling: 'spelling',
    readability: 'readability',
    languageMatch: 'language_match',
} as const;

export type SceModulesTypeof = typeof SCE_MODULES[keyof typeof SCE_MODULES];

export type Module = {
    name: string;
    value: SceModulesTypeof;
    hasAccess: boolean;
};

export type MatchRule = {
    name: string;
    value: string;
};

export type BaseScanExclusion = {
    id?: number | null;
    module?: SceModulesTypeof;
    owner_type?: string;
    default_for_cms: string | null;
    domains: number[];
};

export type AccessibilityScanExclusion = BaseScanExclusion & {
    short_description: string;
    match_rules: {
        accessibility_check_ids: number[];
        type: string;
        value: string;
    }[];
};

export type GenericScanExclusion = BaseScanExclusion & {
    title: string;
    rules: GenericScanRule[];
};

export type ScanExclusion = AccessibilityScanExclusion | GenericScanExclusion;

export interface AutoCompleteCompleteEvent {
    originalEvent: Event;
    query: string;
}

export type ComputedAccessibilityCheck = {
    id: number;
    name: string;
};

export type AccessibilityScanRule = {
    type: string;
    value: string;
    checks: ComputedAccessibilityCheck[];
};

export type GenericScanRule = {
    operator: 'css';
    value: string;
};

export type ScanExclusionDomainsIds = {
    ids?: number[];
    exclude_id?: number | null;
};

export type ScanRule = AccessibilityScanRule | GenericScanRule;
